import React, { Component } from 'react'
import { strVal } from '../../../modules/Utils'
import CustomTable from '../../../elements/Table/CustomTable'
import checkboxHOC from 'react-table-v6/lib/hoc/selectTable'
import { Button } from 'antd'

const CheckboxTable = checkboxHOC(CustomTable)

class List extends Component {
  columns = [
    {
      Header: 'Type',
      accessor: 'kind',
      Cell: ({ value }) => strVal({ value }, 'value').toUpperCase(),
    },
    {
      Header: 'Full Name',
      accessor: 'fn',
      Cell: ({ value, original }) => (
        <a onClick={() => this.props.handleOnRowClick(original)}>{value}</a>
      ),
    },
    {
      Header: 'Full Name',
      accessor: '_id',
    },
    {
      Header: 'Email',
      accessor: 'email.label',
    },
    {
      Header: 'Phone',
      accessor: 'phone.label',
    },
    {
      Header: 'Mobile',
      accessor: 'mobile.label',
    },
  ]

  render() {
    const {
      fetch,
      list,
      tableRef,
      toggleSelection,
      toggleAll,
      isSelected,
      selectAll,
      selection,
      fetchingEmailTemplate,
      showEmail,
      fetching,
    } = this.props
    const checkboxProps = {
      selectType: 'checkbox',
      selectAll,
      isSelected,
      toggleSelection,
      toggleAll,
    }
    return (
      <CheckboxTable
        CreateButton={() => (
          <Button
            size={'small'}
            loading={fetchingEmailTemplate}
            onClick={showEmail}
            disabled={selection.length === 0}
            style={{ float: 'left' }}>
            Email Issuance
          </Button>
        )}
        {...checkboxProps}
        withRef={tableRef}
        columns={this.columns}
        data={list}
        defaultPageSize={20}
        fetching={fetching}
        fetch={fetch}
      />
    )
  }
}

List.propTypes = {}
List.defaultProps = {}

export default List
